import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './AddOnsLoading.Config.Styles';

const titleLoadingConfig = [
  {
    main: setLoadingConfigObject('square', 1, null, styles.titleStyle),
  },
];

const subtitleLoadingConfig = [
  {
    main: setLoadingConfigObject('square', 1, null, styles.subtitleStyle),
  },
];

const recommendedCardLoadingConfig = [
  {
    main: setLoadingConfigObject('square', 1, null, styles.recommendedCardStyle),
  },
];

const addOnsCardLoadingConfig = withUsers => [
  {
    left: setLoadingConfigObject('circle', 1, null, styles.addOnsCardCircle),
    main: setLoadingConfigObject('square', 2, null, styles.addOnsCardSquare),
  },
  {
    ...(withUsers && {
      main: setLoadingConfigObject('square', 1, null, styles.addOnsCardUsersLine),
    }),
  },
];

const requestedAddOnsCardLoadingConfig = [
  {
    left: setLoadingConfigObject('circle', 1, null, styles.addOnsCardCircle),
    main: setLoadingConfigObject('square', 2, null, styles.addOnsCardSquare),
  },
];

const displayChangeLoadingConfig = displayType => [
  {
    containerStyle: styles.displayChange(displayType),
    main: setLoadingConfigObject('square', 1, null),
  },
];

export {
  recommendedCardLoadingConfig,
  addOnsCardLoadingConfig,
  shimmerPlaceholderConfig,
  displayChangeLoadingConfig,
  requestedAddOnsCardLoadingConfig,
  titleLoadingConfig,
  subtitleLoadingConfig,
};
